import { TFunction } from 'i18next';
import { IBenefit } from '@/widgets/BenefitsBlock';
import { RequestAccessModal } from '@/widgets/RequestAccessModal';
import contentImg from 'public/product-pages/content.webp';
import editLandingImg from 'public/product-pages/edit-landing.webp';
import formImg from 'public/product-pages/form.webp';
import landingImg from 'public/product-pages/landing.webp';
import pageCreateImg from 'public/product-pages/page-create.webp';

const images = [landingImg, pageCreateImg, editLandingImg, contentImg, formImg];

export const getPagesBenefits = (t: TFunction): IBenefit[] => {
  const benefits = t('productPages.pages.benefits', { returnObjects: true }) as Array<{
    heading: string;
    description: string;
  }>;
  const bookDemo = t('productPages.pages.bookDemo');

  return benefits.map((benefit, index) => ({
    ...benefit,
    image: images[index]!,
    ...(index === 0 && {
      button: (
        <RequestAccessModal
          alignSelf='start'
          buttonText={bookDemo}
          variant='solid'
          w={{ base: 'full', md: 'fit-content' }}
        />
      ),
    }),
  }));
};
